import React from 'react';
import { Link } from 'react-router-dom';
import { LogoMark } from './LogoMark';
export function PartnerCTA() {
  return <section className="bg-cg-orange-600 py-20" data-id="element-324">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-325">
        <div className="flex justify-center mb-6" data-id="element-326">
          <LogoMark size="lg" variant="dark" data-id="element-327" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-6" data-id="element-328">
          Partner with Chiltern Global
        </h2>
        <p className="text-white/90 max-w-2xl mx-auto mb-10 text-lg" data-id="element-329">
          Discuss your manufacturing requirements with our specialist team.
        </p>
        <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-white text-cg-orange-600 font-bold uppercase tracking-widest rounded-sm hover:bg-navy-900 hover:text-white transition-colors" data-id="element-330">
          Contact Us
        </Link>
      </div>
    </section>;
}